import React from 'react';
import Intro from './intro';
import Menu from './menu';
import Contact from './contact';
import UnityGame from './unityGame';
import { useUnityContext } from 'react-unity-webgl';

const GamesPortfolio = () => {
    const flow = useUnityContext({
        loaderUrl: "/games/flow/Build/Flow.loader.js",
        dataUrl: "/games/flow/Build/Flow.data",
        frameworkUrl: "/games/flow/Build/Flow.framework.js",
        codeUrl: "/games/flow/Build/Flow.wasm",
    });

    const pacman = useUnityContext({
        loaderUrl: "/games/pacman/Build/Pacman.loader.js",
        dataUrl: "/games/pacman/Build/Pacman.data",
        frameworkUrl: "/games/pacman/Build/Pacman.framework.js",
        codeUrl: "/games/pacman/Build/Pacman.wasm",
    });

    const driversDilemma = useUnityContext({
        loaderUrl: "/games/drivers-dilemma/Build/DriversDilemma.loader.js",
        dataUrl: "/games/drivers-dilemma/Build/DriversDilemma.data",
        frameworkUrl: "/games/drivers-dilemma/Build/DriversDilemma.framework.js",
        codeUrl: "/games/drivers-dilemma/Build/DriversDilemma.wasm",
    });

    const furball = useUnityContext({
        loaderUrl: "/games/furball/Build/Furball.loader.js",
        dataUrl: "/games/furball/Build/Furball.data",
        frameworkUrl: "/games/furball/Build/Furball.framework.js",
        codeUrl: "/games/furball/Build/Furball.wasm",
    });

    return (
            <>
                <Intro />
                <Menu />
                <div id="portfolio-wrapper">
                    <div className="container">
                        <div className="row">
                            <h1 className="section-title col-12">AA Games</h1>
                            <div className="col-12">
                                <h3> Twin Harbour Interactive (Formerly Dorado Games) </h3>
                                <p>
                                    Dorado Games is a Malta-based studio specializing in long-term online strategy games.
                                    As one of the few studios to embrace a 4-day work week, it fosters innovation while
                                    expanding its global reach. In 2025, Dorado Games merged with other Stillfront
                                    Group companies to form Twin Harbour Interactive, integrating its titles into the
                                    renowned Supremacy franchise (Supremacy 1914, Call of War 1942, and Supremacy: World War 3),
                                    reaching millions of players worldwide.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="container">
                        <div className="row">
                            <h4 className="col-12 col-sm-8"> Conflict of Nations: World War 3 </h4>
                            <a target="_blank"
                               rel="noopener noreferrer"
                               className="col-10 col-sm-4 order-2 order-sm-1 btn btn-primary d-flex justify-content-center align-items-center play-button"
                               href="https://www.conflictnations.com/"
                            >
                                Play CoN Now!
                            </a>
                            <p className="col-12 col-sm-8 order-1 order-sm-2">
                                Conflict of Nations: World War 3 (renamed to Supremacy: World War 3) — A large-scale, cross-platform real-time strategy
                                game simulating modern global warfare. As a Full-Stack Developer and Team Lead,
                                I worked across the stack to deliver scalable features and real-time systems
                                supporting long-running multiplayer campaigns. I refactored legacy codebases,
                                implemented new features and internal tooling, and created a fully optimized
                                responsive UI for PC players, ensuring seamless interactions for thousands of
                                concurrent users. On the backend, my work focused on facilitating communication
                                between the client and server through well-structured APIs and resolving bugs to
                                maintain stability and performance at scale.
                                In addition to hands-on development, I led a distributed team of engineers,
                                establishing coding standards, mentoring developers, and coordinating closely with design,
                                QA, and live-ops to deliver continuous updates in an agile environment.
                            </p>
                            <img className="col-12 col-sm-4 order-3 order-sm-3" src="/img/CON.png"  alt="Conflict of Nations: World War 3" />
                        </div>
                    </div>
                    <div className="container">
                        <div className="row">
                            <h4 className="col-12 col-sm-8"> Supremacy: Call of War 1942 </h4>
                            <a target="_blank"
                               rel="noopener noreferrer"
                               className="col-10 col-sm-4 order-2 order-sm-1 btn btn-primary d-flex justify-content-center align-items-center play-button"
                               href="https://www.callofwar.com/"
                            >
                                Play CoW Now!
                            </a>
                            <p className="col-12 col-sm-8 order-1 order-sm-2">
                                Call of War: World War II — A cross-platform strategy game recreating World War II
                                on a global scale. As the Team Lead, I focused on evolving and modernizing a
                                long-standing live title with millions of players. My main contributions included
                                integrating new gameplay mechanics, and ensuring
                                technical stability during live feature rollouts.
                                In my leadership role, I guided a mixed-experience team, coordinated cross-discipline
                                efforts with game design and operations, and established development practices
                                that reduced release risk and improved delivery speed for a continuously running live game.
                            </p>
                            <img src="/img/COW.png" className="col-12 col-sm-4 order-3 order-sm-3" alt="Call of War 1942" />
                        </div>
                    </div>
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <h1 className="section-title">Indie Games</h1>
                                <p>
                                    Feel free to browse some of the projects I've worked on! <br />
                                    <b>
                                        Please note: These games were not optimised for web and thus might take a while to load!
                                        For best results open in a new tab.
                                    </b>
                                </p>

                                <UnityGame
                                    name="Flow (Global Game Jam, 2022)"
                                    about = "<p> Join Sir Toebeans in his medieval mayhem adventure! </p> The game is inspired by real longsword fencing techniques, where the aim of the game is to attack and defend at the same time! Use action cards to attack crow bandits whilst defending yourself in order to diminish their health and drive them away. Each card swings your sword in a different direction, attacking one square and defending another. Every attack card lets you swing your sword in a different direction. However, you must pick your attacks carefully! <p>In fencing, flow is the idea that the fastest attack is one starting from the final position of the previous attack. Thus, if you plan which card to play correctly, you will activate ‘flow’ (fast attack) and are guaranteed to hit the enemy! In addition, you are also to defend more areas. </p> Please use 16:9 aspect ratio for the best experience. <a href='https://globalgamejam.org/2022/games/flow-6'>Link to Game Jam Game Page</a> <p> Team Members: Daniel Mercieca, Audrienne Degiorgio and Daniela Attard"
                                    unityProvider={flow.unityProvider}
                                    addEventListener={flow.addEventListener}
                                    removeEventListener={flow.removeEventListener}
                                    imgUrl="flowSS.jpg"
                                    hasEXE={true}
                                    link="flow"
                                />

                                <UnityGame
                                    name="Pacman"
                                    about = "First game every made using unity! PC Version of Pacman 3D. Made using Unity game engine. Download executable folder to run on PC or APK file to run on Android. Mobile version requires google cardboard."
                                    unityProvider={pacman.unityProvider}
                                    addEventListener={pacman.addEventListener}
                                    removeEventListener={pacman.removeEventListener}
                                    imgUrl="pacmanSS.png"
                                    hasAPK={true}
                                    link="pacman"
                                />

                                <UnityGame
                                    name="Driver's Dilemma"
                                    about = "A web-based game developed as a platform for obtaining data by simulating the Trolley Dilemma. The aim was to determine whether the trolley dilemma would be successful in Autonomous cars based on the participants choices in various scenarios."
                                    unityProvider={driversDilemma.unityProvider}
                                    addEventListener={driversDilemma.addEventListener}
                                    removeEventListener={driversDilemma.removeEventListener}
                                    imgUrl="driversSS.png"
                                    link="drivers-dilemma"
                                />

                                <UnityGame
                                    name="FurBall"
                                    about = "The aim of this project was to create a fun and interactive game to help 10 – 12 year olds understand the basic concepts of programming with Prolog. Our game, Furball, was designed using Unity and is intended to teach recursion, backtracking and pattern matching. "
                                    unityProvider={furball.unityProvider}
                                    addEventListener={furball.addEventListener}
                                    removeEventListener={furball.removeEventListener}
                                    imgUrl="furballSS.png"
                                    hasEXE={true}
                                    link="furball"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            <Contact />
        </>
    );
};

export default GamesPortfolio;
